import React, { useEffect, useState } from 'react';
import { TextField, Button, Container, Typography, Alert, Box, Modal, TextareaAutosize, ButtonGroup, IconButton, CircularProgress, Select, MenuItem } from '@mui/material';
import { req, reqPoll } from './ServerUtils';
import ImagesUploader from './ImagesUploader';
import { useParams } from 'react-router-dom';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import InspirationUploader from './InspirationUploader';
import { SetDesigner, SetDesignerWidget } from './SetDesigner';


const TemplateCreator = () => {
  const [id, setId] = useState('');
  const [templateTitle, setTemplateTitle] = useState('');
  const [templateType, setTemplateType] = useState('mako-carousel');
  const [templateInspiration, setTemplateInspiration] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [designer, setDesigner] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  // const [isMako, setIsMako] = useState(true);

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    req('/user_info').then(uinfo => {
      setUserInfo(uinfo);
      if (!uinfo) {
        if (!uinfo.permissions.includes("designer")) {
          req('/sus', 'POST', {
            'reason': 'Unauthorized access attempt to /templates'
          });
        }
        window.location.href = '/login';
        return;
      }
      if (uinfo.permissions.includes("designer")) {
        setDesigner(uinfo.email);
      }
      setLoading(false);
    }).catch(e=> {
      window.location = '/login';
    })
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    const pages = Array.from({ length: pageCount }, (_, i) => ({}));
    req('/admin/html_templates', 'POST', JSON.stringify({
        id,
        title: templateTitle,
        width: 300,
        height: 800,
        designer_email: designer,
        category: templateType,
        pages: pages,
        is_mako: true
    })).then(res => {
        console.log(`Template ID: ${res.id}`);
        window.open(`/template/${res.id}`, '_blank');
    }).catch(error => {
        console.log('Error creating template: ' + error.message);
    })

  };

  if (!userInfo || !userInfo.permissions.includes("designer")) {
    return (<div>Loading...</div>);
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 5, display: 'flex', gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <Box component="form" onSubmit={(e) => e.preventDefault()}>
            <>
            {!designer && <SetDesignerWidget designer={designer} setDesigner={setDesigner} />}
            <TextField
            fullWidth
            label="Id"
            variant="outlined"
            margin="normal"
            value={id}
            onChange={(e) => setId(e.target.value)}
            />
            {/* <Select style={{marginTop: 20}} size="small" fullWidth value={templateType} onChange={(e) => setTemplateType(e.target.value)} sx={{ mb: 2 }}>
                <MenuItem value="listicle">Listicle</MenuItem>
                <MenuItem value="a_vs_b">A vs B</MenuItem>
                <MenuItem value="carousel">Carousel</MenuItem>
                <MenuItem value="mako-carousel">Mako Carousel</MenuItem>
                
                <MenuItem value="certificate">Certificate</MenuItem>
                <MenuItem value="linkedin_banner">Linkedin Banner</MenuItem>
            </Select> */}
            {/* <Select style={{marginTop: 20}} size="small" fullWidth value={isMako} onChange={(e) => setIsMako(e.target.value)} sx={{ mb: 2 }}>
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
            </Select> */}
            <InspirationUploader templateId={id} setTemplateInspiration={setTemplateInspiration} />
        </>
        <TextField fullWidth label="Title" variant="outlined" margin="normal" value={templateTitle} onChange={(e) => setTemplateTitle(e.target.value)} />
        {/* <Select style={{marginTop: 20}} size="small" fullWidth value={templateTitle} onChange={(e) => setTemplateTitle(e.target.value)} sx={{ mb: 2 }}>
            {subjects.map((subject, index) => (
              <MenuItem key={index} value={subject}>{subject}</MenuItem>
            ))}
        </Select> */}
        {/* <TextField type="number" fullWidth label="Page Count" variant="outlined" margin="normal" value={pageCount} onChange={(e) => setPageCount(e.target.value)} /> */}
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button variant="contained" color="primary" onClick={onSave} disabled={loading}>
              Submit
            </Button>
            {loading && <CircularProgress />}
          </Box>
        </Box>
        {error && (
          <Alert severity={error?.startsWith('Error') ? 'error' : 'success'} sx={{ mt: 3 }}>
            {error}
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default TemplateCreator;
